// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"105a655e","297":"4d058161","643":"65fc113b"}[chunkId] + ".chunk.js";
};